module.exports = __webpack_public_path__ + "img/Header5Kopf.732e3927.jpg";